<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-form-checkbox-group :stacked="!properties.showInline">
        <b-row>
          <b-col
            v-for="(column, columnIndex) in fBOptionColumns"
            :key="columnIndex"
          >
            <b-form-checkbox
              :value="option"
              :key="optionIndex"
              :class="properties.showInline ? 'mr-2' : ''"
              v-for="(option, optionIndex) in column"
              >{{ option }}</b-form-checkbox
            >
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <multiple-choice-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-checkbox-group
        v-model="controlValue"
        :stacked="!properties.showInline"
      >
        <b-row>
          <b-col
            v-for="(column, columnIndex) in optionColumns"
            :key="columnIndex"
          >
            <b-form-checkbox
              style="font-size: 14px"
              :value="option"
              :key="optionIndex"
              :class="properties.showInline ? 'mr-2' : ''"
              v-for="(option, optionIndex) in column"
              >{{ option }}</b-form-checkbox
            >
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      <b-row>
        <b-col
          v-for="(column, columnIndex) in optionColumns"
          :key="columnIndex"
        >
          <div
            :class="properties.showInline ? 'd-flex flex-row flex-wrap' : ''"
          >
            <div
              :value="option"
              :key="optionIndex"
              v-for="(option, optionIndex) in column"
              class="mr-2"
            >
              <b-icon-check-square-fill
                class="text-primary"
                v-if="controlValue.indexOf(option) >= 0"
              /><b-icon-square v-else /> {{ option }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { chunkColumns } from "../../../../helpers/general";
import MultipleChoiceV1Properties from "./MultipleChoiceV1Properties.vue";
import collectionServer from "../../../../server/collection";
export default {
  name: "MultipleChoiceV1",
  components: { MultipleChoiceV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {},
      fBOptions: []
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue:
          typeof this.properties.value == "string" &&
          this.properties.value.includes("{{")
            ? this.superComputeFormSubmitterValue({
                elementId: this.id,
                property: "value",
                value: this.properties.value,
                defaultValue: [],
                form: this.form
              })
            : []
      });
    }
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
    }
    if (this.showType == "form-builder") this.getFBOptions();

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async getFBOptions() {
      if (typeof this.properties.options == "string") {
        let re = /\{\{collections.(?:(?!\}\}).)*\}\}/g;
        const matches = [...this.properties.options.matchAll(re)];
        if (
          matches.length == 1 &&
          this.properties.options.startsWith("{{") &&
          this.properties.options.endsWith("}}")
        ) {
          const collections = await collectionServer.query();
          const collection = collections.find(
            c =>
              c.name ==
              this.properties.options.slice(
                14,
                this.properties.options.length - 2
              )
          );
          this.fBOptions = collection.data.items;
        } else this.fBOptions = this.properties.options;
      } else this.fBOptions = this.properties.options;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div class="row">
            ${this.optionColumns
              .map(
                column => `
            <div class="col">
              <div class="${
                this.properties.showInline ? "d-flex flex-row flex-wrap" : ""
              }">
                ${column
                  .map(
                    option => `
                  <div style="font-size: 14px" class="mr-2">
                    ${
                      this.controlValue.indexOf(option) >= 0
                        ? '<i class="fas fa-check-square text-primary"></i>'
                        : '<i class="far fa-square"></i>'
                    } ${option} </div>
                `
                  )
                  .join("")}
              </div>
            </div>
            `
              )
              .join("")}
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    fBOptionColumns() {
      const options = this.fBOptions;

      return chunkColumns(options, this.properties.columnsCount);
    },
    optionColumns() {
      const options = this.computedConditions.options
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: "options",
            value: this.properties.options,
            defaultValue: [],
            form: this.form
          })
        : this.properties.options;

      return chunkColumns(options, this.properties.columnsCount);
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    "properties.options": function() {
      if (this.showType == "form-builder") this.getFBOptions();
    }
  }
};
</script>
